"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.modes = void 0;
// handle erc20 feature others than send.
var ethereumjs_abi_1 = __importDefault(require("ethereumjs-abi"));
var invariant_1 = __importDefault(require("invariant"));
var eip55_1 = __importDefault(require("eip55"));
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var transaction_1 = require("../transaction");
var account_1 = require("../../../account");
var currencies_1 = require("../../../currencies");
var logic_1 = require("../../../compound/logic");
var errors_2 = require("../../../errors");
var infinite = new bignumber_js_1.BigNumber(2).pow(256).minus(1);
function contractField(transaction, currency) {
    var recipientToken = (0, cryptoassets_1.findTokenByAddressInCurrency)(transaction.recipient, currency.id);
    var maybeCompoundToken = (0, currencies_1.findTokenById)((recipientToken === null || recipientToken === void 0 ? void 0 : recipientToken.compoundFor) || "");
    return {
        type: "text",
        label: maybeCompoundToken ? "Contract" : "Address",
        value: maybeCompoundToken
            ? "Compound " + maybeCompoundToken.ticker
            : transaction.recipient
    };
}
/**
 * "erc20.approve" allows a "spender" (e.g. contract address) to consume some erc20 tokens.
 * transaction params:
 * - transaction.recipient address of the spender
 * - transaction.amount in the token unit to allow
 * - transaction.useAllAmount intend to allow infinite amount (setting a very high value)
 */
var erc20approve = {
    fillTransactionStatus: function (a, t, result) {
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        var _a = (subAccount && (0, logic_1.getAccountCapabilities)(subAccount)) || {}, status = _a.status, enabledAmount = _a.enabledAmount;
        (0, transaction_1.validateRecipient)(a.currency, t.recipient, result);
        if (!t.useAllAmount) {
            if (t.amount.eq(0)) {
                result.errors.amount = new errors_1.AmountRequired();
            }
            else if (subAccount &&
                status &&
                enabledAmount &&
                ["EARNING", "SUPPLYING"].includes(status) &&
                t.amount.lt(enabledAmount)) {
                var unit = (0, account_1.getAccountUnit)(subAccount);
                // if account curently supplied we can't lower the initial amount enabled just augment it
                result.errors.amount = new errors_2.CompoundLowerAllowanceOfActiveAccountError(undefined, {
                    minimumAmount: (0, currencies_1.formatCurrencyUnit)(unit, enabledAmount, {
                        disableRounding: true,
                        useGrouping: false,
                        showCode: true
                    })
                });
            }
        }
        result.amount = t.amount;
    },
    fillTransactionData: function (a, t, tx) {
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        (0, invariant_1["default"])(subAccount, "sub account missing");
        // FIXME: make sure it doesn't break
        if (!subAccount)
            throw new Error("sub account missing");
        var recipient = eip55_1["default"].encode(t.recipient);
        var amount;
        if (t.useAllAmount) {
            amount = infinite;
        }
        else {
            (0, invariant_1["default"])(t.amount, "amount missing");
            amount = new bignumber_js_1.BigNumber(t.amount);
        }
        var data = ethereumjs_abi_1["default"].simpleEncode("approve(address,uint256)", recipient, amount.toString(10));
        tx.data = "0x" + data.toString("hex");
        tx.to = subAccount.token.contractAddress;
        tx.value = "0x00";
        return {
            erc20contracts: [recipient]
        };
    },
    fillDeviceTransactionConfig: function (_a, fields) {
        var transaction = _a.transaction, account = _a.account, parentAccount = _a.parentAccount;
        fields.push({
            type: "text",
            label: "Type",
            value: "Approve"
        });
        if (transaction.useAllAmount) {
            fields.push({
                type: "text",
                label: "Amount",
                value: "Unlimited " + (0, account_1.getAccountCurrency)(account).ticker
            });
        }
        else {
            // TODO amount should be just text in future
            fields.push({
                type: "amount",
                label: "Amount"
            });
        }
        fields.push(contractField(transaction, (0, account_1.getMainAccount)(account, parentAccount).currency));
    },
    fillOptimisticOperation: function (_account, _transaction, operation) {
        operation.type = "FEES";
    },
    getResolutionConfig: function () { return ({ erc20: true, externalPlugins: true }); }
};
exports.modes = {
    "erc20.approve": erc20approve
};
//# sourceMappingURL=erc20.js.map